import { render, staticRenderFns } from "./HospitalDetail.vue?vue&type=template&id=87ae3158"
import script from "./HospitalDetail.vue?vue&type=script&lang=ts"
export * from "./HospitalDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports